  <img 
    [src]="url" 
  />